<template>

  <div>
    <div class="card">
      <div class="card-body">
        <div class="row justify-content-between align-items-center">
          <div class="col-6 text-left ">
            <span>{{ vsls[0] != null ? vsls[0].vsl_name : '' }}</span>
          </div>
          <div
            v-if="$route.name === 'analytics'"
            class="col-6 text-right divisao "
            style="padding-left: 14em;"
          >


            <el-dropdown @click.stop>
              <el-select
                  id="filtro-data-analytics"
                v-model="value"
                placeholder="Selecione"
                size="large"
              >
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
                <div
                  class="row"
                  style="margin: 0 1px 0px 0px;"
                >
                  <div class="col">
                    <el-input
                      id="data_inicial"
                      v-model="startDate"
                      class="ajuste-input-date"
                      maxlength="10"
                      show-word-limit
                      type="date"
                    />
                  </div>
                  <div
                    class="col align-self-lg-center"
                    style="padding: 0"
                  >
                    <span>até</span>
                  </div>
                  <div class="col">
                    <el-input
                      id="data_final"
                      v-model="endDate"
                      class="ajuste-input-date"
                      maxlength="10"
                      show-word-limit
                      type="date"
                    />
                  </div>
                  <div
                    class="col"
                    style="padding-left: 0"
                  >
                    <el-button
                      :disabled="endDate <= startDate && endDate !== ''"
                      type="primary"
                      @click="getFilterDataIntervalo"
                    >
                      Filtrar
                    </el-button>
                  </div>
                </div>

              </el-select>
            </el-dropdown>
            <el-button id="atualiza-data-analytics" type="danger" @click="getDataFilter(value)" style="
    margin-left: 9px;
    padding: 11px;" >
            <feather-icon icon="RotateCwIcon"  stroke="white"/>
          </el-button>
          </div>

          <el-button
            v-else
            class="col-2"
            type="primary"
          >
            <span>Embed</span>
            <template #icon>
              <feather-icon
                icon="ThermometerIcon"
                size="18"
                stroke="blue"
                class="mr-50"
              />
            </template>
          </el-button>
        </div>

      </div>
    </div>

    <PersonPlayVideo
      v-model="vsls[0]"
      :analise="analise"
      :src-video="getPathVideoBucket"
      :timeds="timeds"
    >
      <template #message-nosuported>
        <span>Seu navegador não suporta esse videos</span>
      </template>
    </PersonPlayVideo>
    <StatusVideo
      v-if="$route.name === 'analytics'"
      v-model="analise"
    />
  </div>
</template>
<script>
import { VslService } from '@/services/Vsl'
import {
  BAlert, BLink, BCard, BCardText,
} from 'bootstrap-vue'
import VideoPlayerCustom from '@/components/analytics/VideoPlayerCustom.vue'
import PersonPlayVideo from '@/components/PersonPlayVideo'
import { AnalyticService } from '@/services/Analytic'
import StatusVideo from '@/components/analytics/StatusVideos'
import { TimedsService } from '@/services/AnalyticTimeds'
import { formatDate } from '@core/utils/dateFormat'

const analyticService = new AnalyticService()
const timedsService = new TimedsService()
export default {
  components: {
    PersonPlayVideo,
    BAlert,
    BLink,
    BCard,
    BCardText,
    VideoPlayerCustom,
    StatusVideo,
  },
  nome: 'Videos',
  data() {
    return {
      dataIsValid: false,
      startDate: null,
      endDate: null,
      timeds: null,
      analise: null,
      valorTime: null,
      vslId: this.$route.params.vslId,
      contentWidth: this.$store.state.appConfig.layout.contentWidth,
      loading: false,
      vsls: [],
      errorMessage: null,
      isPlayer: false,

      user_player: {
        qtd_pause: 0,
        qtd_player: 0,
        time: '',
      },
      options: [{
        value: 'hoje',
        label: 'Hoje',
      }, {
        value: 'ontem',
        label: 'Ontem',
      }, {
        value: 'sete_dias',
        label: 'Últimos 7 dias',
      }, {
        value: 'trinta_dias',
        label: 'Últimos 30 dias',
      }, {
        value: 'full_dias',
        label: 'Tempo todo',
      },
      ],
      value: 'sete_dias',
    }
  },
  computed: {
    getPathVideoBucket() {
      if (['', null, undefined].indexOf(this.vsls[0]) === -1) {
        return this.vsls[0].vsl_bucket_address
      }
      return ''
    },
    analiseComputed() {
      return this.analise
    },
    getTime() {
      return this.varVideo.currentTime
    },
    timedsComp() {
      return this.timeds
    },
  },
  watch: {
    value(newValue) {
      if (newValue) {
        this.getDataFilter(newValue)
      }
    },
  },

  async created() {
    this.varVideo = this.$refs.myVideo
    try {
      this.loading = true
      const response = await VslService.getVsl(this.vslId)
      this.vsls = response.data

      this.loading = false
    } catch (error) {
      this.errorMessage = error
      this.loading = false
    }
  },
  async mounted() {
    if (this.$route.name === 'analytics') {
      this.getDataFilter(this.value)
    }
    if (typeof this.$route.params.vslId !== 'undefined') {
      this.vslId = this.$route.params.vslId
      this.loading = true
      await analyticService.getByIdVsl(this.vslId).then(resp => {
        this.analise = resp
        this.loading = false
      })
    }
  },

  methods: {
    getDataFilter(type_date) {
      const dataFilter = new Date()
      if (typeof type_date === "undefined"){
        console.log("entrei")
        this.getFilterData7days(dataFilter)
      }
      if (type_date === 'hoje') {
        this.getFilterDateHoje(dataFilter)
      }
      if (type_date === 'ontem') {
        this.getFilterDataOtem(dataFilter)
      }
      if (type_date === 'sete_dias') {
        this.getFilterData7days(dataFilter)
      }
      if (type_date === 'trinta_dias') {
        this.getFilterData30days(dataFilter)
      }
      if (type_date === 'full_dias') {
        this.getFilterDataTempoTodo(dataFilter)
      }
    },
    async getFilterDateHoje(dataFilter) {
      await timedsService.getTimedByIdVsls(this.vslId, {
        start_date: `${formatDate(dataFilter)}`,
        end_date: `${formatDate(dataFilter)}`,
      })
        .then(res => {
          if (res.data.length > 0) {
            this.timeds = JSON.parse(JSON.stringify(res.data))
            return
          }
          this.timeds = []
        })

      await analyticService.getByIdVsl(this.vslId, {
        start_date: `${formatDate(dataFilter)}`,
        end_date: `${formatDate(dataFilter)}`,
      }).then(resp => {
        this.analise = resp
      })
    },
    async getFilterDataOtem(dataFilter) {
      dataFilter.setDate(dataFilter.getDate() - 1)

      await timedsService.getTimedByIdVsls(this.vslId, {
        start_date: `${formatDate(dataFilter)}`,
        end_date: `${formatDate(dataFilter)}`,
      })
        .then(res => {
          if (res.data.length > 0) {
            this.timeds = JSON.parse(JSON.stringify(res.data))
            return
          }
          this.timeds = []
        })

      await analyticService.getByIdVsl(this.vslId, {
        start_date: `${formatDate(dataFilter)}`,
        end_date: `${formatDate(dataFilter)}`,
      }).then(resp => {
        this.analise = resp
      })
    },
    async getFilterData7days(dataFilter) {
      const current_date = new Date()
      dataFilter.setDate(dataFilter.getDate() - (7 - dataFilter.getDay() + 1))
      await timedsService.getTimedByIdVsls(this.vslId, {
        start_date: `${formatDate(current_date)}`,
        end_date: `${formatDate(dataFilter)}`,
      })
        .then(res => {
          if (res.data.length > 0) {
            this.timeds = JSON.parse(JSON.stringify(res.data))
            return
          }
          this.timeds = []
        })

      await analyticService.getByIdVsl(this.vslId, {
        start_date: `${formatDate(current_date)}`,
        end_date: `${formatDate(dataFilter)}`,
      }).then(resp => {
        this.analise = resp
      })
    },
    async getFilterData30days(dataFilter) {
      const current_date = new Date()
      dataFilter.setDate(dataFilter.getDate() - (30 - dataFilter.getDay() + 1))
      this.endDate = `${formatDate(current_date)}`
      this.startDate = `${formatDate(dataFilter)}`
      timedsService.getTimedByIdVsls(this.vslId, {
        start_date: `${formatDate(current_date)}`,
        end_date: `${formatDate(dataFilter)}`,
      })
        .then(res => {
          if (res.data.length > 0) {
            this.timeds = JSON.parse(JSON.stringify(res.data))
            return
          }
          this.timeds = []
        })

      await analyticService.getByIdVsl(this.vslId, {
        start_date: `${formatDate(current_date)}`,
        end_date: `${formatDate(dataFilter)}`,
      }).then(resp => {
        this.analise = resp
      })
    },
    async getFilterDataTempoTodo(dataFilter) {
      await timedsService.getTimedByIdVsls(this.vslId)
        .then(res => {
          console.log('res-tempo-todo', res)
          if (res.data.length > 0) {
            this.timeds = JSON.parse(JSON.stringify(res.data))
            console.log('times', this.timeds)
            return
          }
          this.timeds = []
        })

      await analyticService.getByIdVsl(this.vslId).then(resp => {
        this.analise = resp
      })
    },
    async getFilterDataIntervalo() {
      console.log(this.endDate < this.startDate)
      await timedsService.getTimedByIdVsls(this.vslId, {
        start_date: `${this.startDate}`,
        end_date: `${this.endDate}`,
      })
        .then(res => {
          if (res.data.length > 0) {
            this.timeds = JSON.parse(JSON.stringify(res.data))
            return
          }
          this.timeds = []
        })

      await analyticService.getByIdVsl(this.vslId, {
        start_date: `${this.startDate}`,
        end_date: `${this.endDate}`,
      }).then(resp => {
        this.analise = resp
      })
    },
    gitTimeVideo(time) {
      let min = parseInt(time % 60)
      if (min <= 9) {
        min = `0${min}`
      } else {
        min = min
      }
      return `${parseInt(time / 60)}:${min}`
    },
    player() {
      this.isPlayer = !this.isPlayer
      if (this.isPlayer) {
        this.user_player.qtd_player++
        this.$refs.myVideo.play()
      } else {
        this.user_player.qtd_pause++
        this.user_player.time = this.gitTimeVideo(this.$refs.myVideo.currentTime)
        this.$refs.myVideo.pause()
      }
    },
    video(item) {
      this.$router.push(`/player/${item}`)
    },

    deleteVSL(vslId) {
      try {
        this.loading = true
        VslService.deleteVsl(vslId).then(response => {
          if (response) {
            VslService.getALLVsls().then(response => {
              this.vsls = response.data
              this.loading = false
            })
          }
        })
      } catch (error) {
        this.errorMessage = error
        this.loading = false
      }
    },

    comecar() {
      const video = document.getElementsByClassName('video-screen')[0]
      video.play()
    },
    pause() {
      const video = document.getElementsByClassName('video-screen')[0]
      video.pause()
    },
    stop() {
      const video = document.getElementsByClassName('video-screen')[0]
      video.pause()
      video.currentTime = 0
    },
    dec() {
      const video = document.getElementsByClassName('video-screen')[0]
      video.playbackRate -= 0.10
    },
    inc() {
      const video = document.getElementsByClassName('video-screen')[0]
      video.playbackRate += 0.10
    },
    retroceder() {
      const video = document.getElementsByClassName('video-screen')[0]
      video.currentTime -= 10
    },
    avancar() {
      const video = document.getElementsByClassName('video-screen')[0]
      video.currentTime += 10
    },

    aparecer() {
      const myDiv = document.getElementsByClassName('control')

      myDiv.classList.add('bg-dark')
    },

  },

}
</script>
<style scoped>
input[type=date], .ajuste-input-date {
  width: 170px
}
video {
  width: 100%;
  height: auto;
}
.control{
  width: 100%;
  height: 100%;
  position: absolute;
  bottom: 0;
  top: 100%;
  transform: translateY(-15%);
  display: block;
}

v-container {
  position: relative;
  margin-bottom: 10px;
  width: 540px;
}

.btna {
  font-size: 20px;
  width: 10%;
;
}.control{
   width: 100%;
   height: 100%;
   position: absolute;
   bottom: 0;
   top: 100%;
   transform: translateY(-15%);
   display: block;


 }

v-container {
  position: relative;
  margin-bottom: 10px;
  width: 540px;
}

.btna {
  font-size: 20px;
  width: 10%;
}
.divisao{
  display: inline-flex;
}
</style>
